import consts from '../../../consts'

export function CampoForm(props) {
    const meta = (props.meta !== undefined ? props.meta : { error: '', touched: '' })
    let iconesEsq = props.iconesEsq || []
    let iconesDir = props.iconesDir || []

    //Dados de anexo
    const anexo = ((props.anexo && !props.anexoIcone) ? <a href={consts.linkRepositorio + props.anexo}
        title={(props.textoAnexo ?? "Download anexo")} target="_blank" rel="noreferrer"
        download><i className="fas fa-paperclip"></i></a> : '')

    if (props.anexo && props.anexoIconeEsq) {
        iconesEsq = [
            ...iconesEsq,
            {
                icone: 'fas fa-paperclip text-primary',
                link: consts.linkRepositorio + props.anexo,
                target: '_blank',
                download: true,
                titleIcone: (props.textoAnexo ?? "Download anexo")
            }
        ]
    }

    if (props.anexo && props.anexoIconeDir) {
        iconesDir = [
            ...iconesDir,
            {
                icone: 'fas fa-paperclip text-primary',
                link: consts.linkRepositorio + props.anexo,
                target: '_blank',
                download: true,
                titleIcone: (props.textoAnexo ?? "Download anexo")
            }
        ]
    }

    return (
        <div className={`form-group${(props.classe ? ' ' + props.classe : '' )}`}>
            {((props.label) ? <label htmlFor={props.nome}>{props.label + (props.obrigatorio ? ' * ' : ' ')}{anexo}</label> : null)}
            <div className={`${!props.semCampo ? 'input-group' : ''}${(props.classe ? ' ' + props.classe : '')}${(((meta.error) && (meta.touched)) ? ' is-invalid' : '')}`}>
                {((props.iconeEsq) ? 
                    <div className="input-group-prepend">
                        <div className="input-group-text pointer">
                            <i className={`fas fa-${props.iconeEsq}`}></i>
                        </div>
                    </div>
                : null)}
                {iconesEsq.map((obj, index) => {
                    return (
                        <div key={index} className="input-group-append">
                            <a className="input-group-text pointer"
                                href={(obj.link && obj.link)}
                                title={obj.titleIcone}
                                target={(obj.target ? obj.target : '_self')}
                                download={obj.download}
                                onClick={(e) => { if ((obj.onClick) && (!props.readOnly)) { obj.onClick(obj.parametro) } }}>
                                <i className={`fas fa-${obj.icone}`}></i>
                            </a>
                        </div>
                    )
                })}
                {props.children}
                {iconesDir.map((obj, index) => {
                    return (
                        <div key={index} className="input-group-append">
                            <a className="input-group-text pointer"
                                href={(obj.link ? obj.link : null)}
                                title={obj.titleIcone}
                                target={(obj.target ? obj.target : '_self')}
                                download={obj.download}
                                onClick={(e) => { if ((obj.onClick) && (!props.readOnly)) { obj.onClick(obj.parametro) } }}>
                                <i className={`fas fa-${obj.icone}`}></i>
                            </a>
                        </div>
                    )
                })}
                {((props.iconeDir) ? 
                    <div className="input-group-append">
                        <a className="input-group-text pointer"
                            href={consts.linkApp}
                            title={props.titleIconeDir}
                            onClick={(e) => { if ((props.onClickDir) && (!props.readOnly)) { props.onClickDir() } }}>
                            <i className={`fas fa-${props.iconeDir}`}></i>
                        </a>
                    </div>
                : null)}
            </div>
            {(((meta.error) && (meta.touched)) ? <span className="error invalid-feedback">{meta.error}</span> : null)}
        </div>
    )
}